// Lets the hooks sharing a map (`useFacilities`...) follow the base layer `useGeoveloMap` applies,
// without every app having to thread it through to them.
const baseLayers = new WeakMap();
export const baseLayerChangeEvent = 'geovelo:baselayerchange';
export function getMapBaseLayer(map) {
  return baseLayers.get(map);
}
export function setMapBaseLayer(map, baseLayer) {
  if (baseLayers.get(map) === baseLayer) return;
  baseLayers.set(map, baseLayer);
  map.fire(baseLayerChangeEvent);
}